/* eslint-disable react/jsx-no-bind */
import React, {Component} from 'react';
import './SessionDetails.less';
import {FormInput} from '@homeaway/react-form-components';

class SessionDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sessionId: ''
        };
    }

    render() {
        const userInfo = (
            <div>
                <h1> {'Details of your current session'} </h1>
                <form role="form">
                    <FormInput
                        name= "principalUUID"
                        label="You are impersonator with UUID:"
                        value={this.props.session.principalUuid}
                        readOnly
                    />
                    <FormInput
                        name="subjectUUID"
                        label="You are impersonating subject UUID:"
                        value={this.props.session.subjectUuid}
                        readOnly
                    />
                </form>
            </div>
        );
        return (userInfo);
    }
}

export default SessionDetails;
